var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"links"},[_c('f-simple-navigation',{attrs:{"items":_vm.links,"render-nav":false,"icon-size":"16","vertical":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }